<style lang="scss">
  @use "../../../assets/css/design-system/mixins";
  @use "../../../assets/css/design-system/colors";
  @use "../../../assets/css/design-system/utils";

  div.subject-line {
    margin: 2px;
    @include mixins.body2();
    display: flex;
    align-items: center;
    @include colors.background-color(interfaceSwGrey_5);
    @include colors.color(textGrey);

    padding: utils.in_rem(6px) utils.in_rem(6px) utils.in_rem(6px)
      utils.in_rem(8px);
    border-radius: 12px;
    gap: utils.in_rem(8px);

    > div {
      @include colors.color(black_90);
      flex: 1 1 auto;
    }
  }
</style>

<script>
  import TinyMCE from "./TinyMCE.svelte";

  export let height = 34;
  // inline editor does not work in the shadow dom.
  // https://github.com/tinymce/tinymce/issues/6158
  let options = {
    plugins: "paste",
    paste_as_text: true,
    menubar: false,
    toolbar: false,
    statusbar: false,
    powerpaste_word_import: "clean",
    powerpaste_html_import: "clean",
    paste_preprocess: (_, args) => {
      // Remove all HTML tags and collapse into a single paragraph
      args.content = args.content.replace(/<\/?[^>]+(>|$)/g, " "); // Strip HTML tags
      args.content = args.content.replace(/\s+/g, " ").trim(); // Normalize whitespace
      // Wrap in a single paragraph node
      /* args.content = `<p>${args.content}</p>`; */
    },
    height,
    width: "100%",
    skin_url: "/assets/css/design-system/tinymce/subject",
    content_css: false,
    content_style: `
body {
   height: ${height}px;
}`,
    setup: (editor) => {
      editor.on("keydown", (event) => {
        // Prevent newlines
        if (event.key === "Enter" || event.key === "Return") {
          event.preventDefault();
        }
      });
    },
  };

  export let value;
</script>

<div class="subject-line">
  Subject
  <TinyMCE
    class="flex-1 subject-line"
    tag="input"
    format="text"
    {...options}
    bind:value
  />
</div>
